// The assistant's sparkle, drawn like the rest of the sidebar set: 26x26,
// 1.5px stroke, round joins, txt-secondary by default. The filled sparkle in
// icons/header/AiIcon is the same glyph for the mobile navbar pill and the
// panel header; this one exists so the sidebar row doesn't sit solid among
// outlined neighbours.
export const AssistantIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg {...props} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M11 3.25L12.95 8.55C13.15 9.1 13.58 9.53 14.13 9.73L19.43 11.68L14.13 13.63C13.58 13.83 13.15 14.26 12.95 14.81L11 20.11L9.05 14.81C8.85 14.26 8.42 13.83 7.87 13.63L2.57 11.68L7.87 9.73C8.42 9.53 8.85 9.1 9.05 8.55L11 3.25Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M20 15.7L20.98 18.36C21.08 18.63 21.3 18.85 21.57 18.95L24.23 19.93L21.57 20.91C21.3 21.01 21.08 21.23 20.98 21.5L20 24.16L19.02 21.5C18.92 21.23 18.7 21.01 18.43 20.91L15.77 19.93L18.43 18.95C18.7 18.85 18.92 18.63 19.02 18.36L20 15.7Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default AssistantIcon;
